import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationService } from '@/services/notification.service';
import { EventStatus } from '@/interfaces/entities/event';
import { commentService } from '@/services/comments.service';

const useChangeCommentStatus = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			commentId,
			status,
		}: {
			commentId: number;
			status: EventStatus;
		}) => await commentService.changeStatus(commentId, status),
		onSuccess: () => {
			notificationService.success('status changed successfully');
			queryClient.invalidateQueries({ queryKey: ['comment'] });
		},
	});
};

export default useChangeCommentStatus;
